import ExtensionTableDTOAbstract from "./ExtensionTableDTOAbstract";

/**
 * For a given group of samples, build off of their extension table if applicable in order to display additional information
 */
export default class SubmissionExtensionTableDTO extends ExtensionTableDTOAbstract {

    ExtensionEnum = {
        Soil: {
            attribute_1: 'grower',
            attribute_2: 'zone',
        },
        Tissue: {
            attribute_1: 'grower',
            attribute_2: 'crop',
            attribute_3: 'cropstage'
        },
        Water: {
            attribute_1: 'usage',
        }
    };

    formatType(submission) {
        // we will need a connection to the sample type in order to do this
        switch (submission.sample_type.name) {
            case 'Tissue':
            case 'Soil':
            case 'Water':
                return {
                    type: submission.sample_type.name,
                    fields: this.formatTable(submission.sample_type.name, this.getSubmissionExtensionData(submission))
                };
            default:
                // if there is nothing then we can just return an empty array
                return [];
        }
    }

    /**
     * Returns the given submissions into a formatted array based on type with updated fields
     * @param submissions The list of all submissions that we will need to check on
     * @returns Formatted addition to the table array
     */
    static run(submissions) {
        const ctx = new SubmissionExtensionTableDTO();
        return ctx.setExtensionTypes(submissions);
    }

    static getHoverTextStatic(submission, attributeNumber) {
        const ctx = new SubmissionExtensionTableDTO();
        return ctx.convertToSentenceCase(ctx.getHoverText(submission.sample_type.name, attributeNumber));
        
    }

    getSubmissionExtensionData(submission) {
        return submission[`submission_${submission.sample_type.name.toLowerCase()}`];
    }

}